import moment from "moment";
import { isAfter, isBefore } from "date-fns";
import { isNumber, isString } from "lodash";
export function toDate(date) {
  if (isNumber(date) || isString(date)) {
    return moment(date).toDate();
  }
  if (moment.isMoment(date)) {
    return date.toDate();
  }
  return date;
}
export function getHoursAndMinutes(minutes) {
  return {
    hours: Math.floor(Number(minutes) / 60),
    minutes: Number(minutes) % 60
  };
}
export function isWithinRange(date, minDate, maxDate) {
  if (minDate !== undefined && isBefore(date, minDate)) return false;
  if (maxDate !== undefined && isAfter(date, maxDate)) return false;
  return true;
}
//# sourceMappingURL=utils.js.map